<template>
  <div class="plant-wrapper">
    <div class="plant-wrapper-top">
      <div class="handle-wrapper" @click="backPath"><div class="icon-font">&#xe612;</div>返回</div>
      <div class="plant-wrapper-top-title">虫情杀虫申请</div>
      <div class="handle-wrapper" @click="handleData"><div class="icon-font">&#xe653;</div>提交</div>
    </div>
    <div class="plant-deal-content" v-if="loading">
      <div class="loading-data">
        <i class="el-icon-loading"></i>
        <div>加载中，请稍后···</div>
      </div>
    </div>
    <div class="plant-deal-content" v-if="!loading">
      <div class="plant-deal-content-wrapper">
        <div class="input-contain">
          <div class="input-title">申请编号：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.applyNum" disabled="disabled"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">仓库位置：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.siteName" disabled="disabled"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">负责人：</div>
          <div class="input-wrapper">
            <input v-model="inputValue.principalName" disabled="disabled"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">杀虫日期：</div>
          <div class="input-wrapper" style="margin-right: 0">
            <el-date-picker
              prefix-icon=""
              v-model="inputValue.killPestTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="input-contain">
          <div class="input-title">完成日期：</div>
          <div class="input-wrapper">
            <el-date-picker
              prefix-icon=""
              v-model="inputValue.finishTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="wrapper-title">
          <div>杀虫方式：</div>
          <div class="text-wrapper">
            <label>
              <textarea v-model="inputValue.killPestType" rows="5"></textarea>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {applyInfo, handleApply} from '../../../api/maintain'
import {noEmpty} from '../../../tools/methods'
export default {
  name: 'ApplyPlant',
  data () {
    return {
      loading: true,
      custodianValue: [],
      inputValue: {
        pestDetailId: '',
        applyNum: '',
        killPestTime: '',
        finishTime: '',
        killPestType: '',
        principalId: '',
        principalName: '',
        siteId: '',
        siteName: '',
        siteType: ''
      }
    }
  },
  created () {
    let body = {
      pestDetailId: this.$route.query.pestDetailId,
      requestType: '01'
    }
    applyInfo(body).then(res => {
      console.log(res)
      this.inputValue = {
        pestDetailId: res.data.pestDetailId,
        applyNum: res.data.applyNum,
        siteId: res.data.siteId,
        siteName: res.data.siteName,
        siteType: res.data.siteType,
        killPestTime: '',
        finishTime: '',
        killPestType: '',
        principalId: res.data.principalId,
        principalName: res.data.principalName
      }
      this.loading = false
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    backPath: function () {
      this.$router.go(-1)
    },
    handleData: function () {
      if (
        noEmpty(this.inputValue.killPestTime, '请选择杀虫日期', '') &&
        noEmpty(this.inputValue.finishTime, '请选择完成日期', '')
      ) {
        handleApply(this.inputValue).then(res => {
          console.log(res)
          if (res.code === 500) {
            this.$message({
              message: res.data,
              type: 'warning',
              center: 'true',
              duration: '1000'
            })
          } else {
            this.$message({
              message: res.data,
              type: 'success',
              center: 'true',
              duration: '1000'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style scoped>
  @import "Plant.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/plant/ApplyPlant.vue